"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FixedPriceShippingRule = void 0;
const utils_1 = require("../utils");
const base_1 = require("./base");
class FixedPriceShippingRule extends base_1.BaseShippingRule {
    constructor(props) {
        super(props);
        this.props = props;
    }
    /**
     * Get fixed price
     * @returns {number}
     */
    get fixedPrice() {
        return this.props.settings.fixedPrice;
    }
    /**
     * Get shipping price for particular rule
     *
     * but having parameter as unused in order to keep the same signature across the whole thing
     * @param _productSKUs
     */
    getShippingPrice(_productSKUs) {
        return this.fixedPrice;
    }
    /**
     * Apply shipping rule
     * @param cart
     */
    applyShippingRule(cart) {
        if (!this.isMatchedSelectedShippingMethod(cart)) {
            return cart;
        }
        const selectedProductIds = this.selectedProducts.map((selectedProduct) => selectedProduct.id);
        const hasSelectedProducts = (0, utils_1.hasSomeSelectedProductsInProductSKUs)(cart.productSKUs, selectedProductIds);
        if (!hasSelectedProducts) {
            return cart;
        }
        const newCart = Object.assign({}, cart);
        // shipping price for particular shipping rule
        const shippingPrice = this.getShippingPrice(newCart.productSKUs);
        return Object.assign(Object.assign({}, newCart), { 
            // Add cart shipping price with current shipping price
            shippingPrice: newCart.shippingPrice + shippingPrice, 
            // Save applied shipping rule
            shippingRules: newCart.shippingRules.concat([Object.assign(Object.assign({}, this.props), { shippingPrice })]) });
    }
}
exports.FixedPriceShippingRule = FixedPriceShippingRule;
//# sourceMappingURL=fixed-price.js.map